import { render, staticRenderFns } from "./TheRealVideoDimensionsReferenceOverlay.vue?vue&type=template&id=5924848e&scoped=true&lang=html&"
import script from "./TheRealVideoDimensionsReferenceOverlay.vue?vue&type=script&lang=ts&"
export * from "./TheRealVideoDimensionsReferenceOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./TheRealVideoDimensionsReferenceOverlay.vue?vue&type=style&index=0&id=5924848e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924848e",
  null
  
)

export default component.exports